package dev.sasikanth.twine.common.ui.theme

import androidx.compose.ui.unit.dp

object ElevationTokens {
  val Level0 = 0.0.dp
  val Level1 = 1.0.dp
  val Level2 = 3.0.dp
  val Level3 = 6.0.dp
  val Level4 = 8.0.dp
  val Level5 = 12.0.dp
}
